module.exports = require("vm");


//////////////////
// WEBPACK FOOTER
// external "vm"
// module id = 87
// module chunks = 0 1